import React from "react";

const SaveIcon = () => {
  return (
    <svg
      className="star"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16.6 15.79"
    >
      <path d="M8.71 12.53a.75.75 0 0 0-.83 0l-4.46 3.18c-.23.16-.35.09-.26-.19l1.65-5.22a.75.75 0 0 0-.26-.79L.15 6.24c-.23-.17-.19-.31.1-.31h5.48a.75.75 0 0 0 .67-.53L8.14.2c.09-.27.23-.28.32 0l1.74 5.2a.75.75 0 0 0 .67.49h5.48c.28 0 .34.13.1.31L12 9.5a.75.75 0 0 0-.26.79l1.65 5.22c.08.27 0 .36-.26.19z" />
    </svg>
  );
};

export default SaveIcon;
